import { jwtDecode } from "jwt-decode"


const getToken = () => {
  let token = localStorage.getItem('token');

  // Verificar si el token existe antes de intentar decodificarlo
  if (token) {
    const decodedToken = jwtDecode(token);
    return { decodedToken, token: token };
  } else {
    // En caso de que el token esté vacío o sea nulo
    return { decodedToken: null, token: null };
  }
}

const copyToClipboard = (str) => {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText)
    return navigator.clipboard.writeText(str);
  return Promise.reject("The Clipboard API is not available.");
};

function obtenerFechaYHoraActual() {
  const ahora = new Date();

  // Obtener la hora y los minutos
  let horas = ahora.getHours();
  let minutos = ahora.getMinutes();

  // Formatear las horas y los minutos para que siempre tengan dos dígitos
  horas = horas < 10 ? '0' + horas : horas;
  minutos = minutos < 10 ? '0' + minutos : minutos;

  // Obtener el día, el mes y el año
  const dia = ahora.getDate();
  const mes = ahora.getMonth() + 1; // Los meses van de 0 a 11, por eso sumamos 1
  const año = ahora.getFullYear();

  // Construir la cadena de fecha y hora en el formato deseado
  const fechaYHora = `${horas}:${minutos}hs ${dia}/${mes}/${año}`;

  return fechaYHora;
}
function convertirFecha(fechaString) {
  const fecha = new Date(fechaString);
  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1;
  const año = fecha.getFullYear();
  const hora = fecha.getHours();
  const minutos = fecha.getMinutes();
  const diaFormateado = dia < 10 ? '0' + dia : dia;
  const mesFormateado = mes < 10 ? '0' + mes : mes;
  const horaFormateada = hora < 10 ? '0' + hora : hora;
  const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;
  const fechaFormateada = 
  `${horaFormateada}:${minutosFormateados}hs - ${diaFormateado}/${mesFormateado}/${año}`;
  return fechaFormateada;
}
export { getToken, copyToClipboard, obtenerFechaYHoraActual , convertirFecha}